module.exports = {
      id: "light-25(1s)index-usage",
      viewBox: "0 0 33 32",
      url: __webpack_public_path__ + "sprite-dd90e0.smartcharts.svg#light-25(1s)index-usage",
      toString: function () {
        return this.url;
      }
    }